"use client";
import { MenuProps } from "antd";
import Link from "next/link";
import React, { useEffect, useState } from "react";

const useMenuItem = () => {
  const [hasMounted, setHasMounted] = useState(false);
  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- Setting mounted state on client is intentional to avoid hydration mismatch
    setHasMounted(true);
  }, []);

  if (!hasMounted) return [];

  type MenuItem = Required<MenuProps>["items"][number];

  const menuItems: MenuItem[] = [
    {
      key: "home",
      label: (
        <Link href="/" rel="noopener noreferrer">
          صفحه اصلی
        </Link>
      ),
    },
    {
      key: "about",
      label: (
        <Link href="/about" rel="noopener noreferrer">
          درباره ما
        </Link>
      ),
    },
    {
      key: "services",
      label: (
        <Link href="/services" rel="noopener noreferrer">
          خدمات
        </Link>
      ),
    },
    {
      key: "products",
      label: (
        <Link href="/products" rel="noopener noreferrer">
          محصولات
        </Link>
      ),
    },
    {
      key: "contact",
      label: (
        <Link href="/contactus" rel="noopener noreferrer">
          تماس با ما
        </Link>
      ),
    },
    {
      key: "calculator",
      label: (
        <Link href="/calculator" rel="noopener noreferrer">
          ماشین حساب زیان
        </Link>
      ),
    },
  ];
  return menuItems;
};

export default useMenuItem;
